import { render, staticRenderFns } from "./ThumbListIcon.vue?vue&type=template&id=506ff9a2&"
import script from "./ThumbListIcon.vue?vue&type=script&lang=js&"
export * from "./ThumbListIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports